import app from "../_app";

const markup = document.querySelector('.js-product-markup');

if (markup) {
    const variantsDataElement = markup.querySelector('.js-product-markup-variants');
    const weight = markup.querySelector('.js-product-markup-weight');
    const weightValue = markup.querySelector('.js-product-markup-weight-value');
    const price = markup.querySelector('.js-product-markup-price');
    const priceText = markup.querySelector('.js-product-markup-price-text');
    const variantsCheckboxes = [...document.querySelectorAll('.js-product-variant')];
    let variantsData = {};

    try {
        variantsData = JSON.parse(variantsDataElement.textContent);
    } catch (error) {
        console.error('Unable to parse product markup variant data', error);
    }

    const variantChangeHandler = (variant) => {
        const variantData = variantsData[variant.value];

        if (variant.dataset.price) {
            price.innerText = app.currency(variant.dataset.price);
        }

        if (!variantData) {
            return;
        }

        weightValue.innerText = variantData.weight;
        weight.classList.toggle('d-none', !variantData.weight);

        priceText.innerText = variantData.priceText;
        priceText.classList.toggle('d-none', !variantData.priceText);
    };

    const selectedVariantHandler = () => {
        const selectedVariant = variantsCheckboxes.find(variant => variant.checked);

        if (selectedVariant) {
            variantChangeHandler(selectedVariant);
        }
    };

    variantsCheckboxes.map(variant => variant.addEventListener('change', ({currentTarget}) => variantChangeHandler(currentTarget)));

    // The browser restores the selected variant on a back navigation after the markup was rendered.
    window.addEventListener('pageshow', selectedVariantHandler);
}
